import { MailOpen } from "lucide-react";
import { useNavigate } from "react-router";
import { useSignOut } from "../lib/queries";
import type { User } from "../lib/types";
import { ProfileWizard } from "./new-profile/ProfileWizard";

/**
 * Shown instead of the dashboard while the signed-in user belongs to no profile: the profile
 * wizard, plus a pointer to invitations for people joining an existing business.
 */
export function OnboardingPage({ user }: { user: User }) {
  const signOut = useSignOut();
  const navigate = useNavigate();

  return (
    <ProfileWizard
      header={() => (
        <span className="flex items-center gap-3 text-[0.8125rem] text-fg-muted">
          <span className="hidden sm:inline">{user.email}</span>
          <button
            type="button"
            onClick={() => signOut.mutate()}
            disabled={signOut.isPending}
            className="font-medium text-accent hover:underline"
          >
            Sign out
          </button>
        </span>
      )}
      footer={
        <div className="flex gap-2.5 rounded-md bg-subtle px-3 py-2.5 text-xs text-fg-muted">
          <MailOpen aria-hidden="true" className="mt-px size-4 shrink-0" />
          <p>
            Joining an existing business? Open the invitation link sent to{" "}
            <span className="font-medium text-fg">{user.email}</span> to accept it.
          </p>
        </div>
      }
      // The dashboard mounts with the new profile as soon as /me lists it.
      onFinish={(_, to) => navigate(to, { replace: true })}
    />
  );
}
